import { getWinningTeamRequest } from "../repositories/winning_team_repository";
export const WinningTeamService = () => {
    const fetchWinningTeams = async (setWinningTeams) => {
        try {
            const response = await getWinningTeamRequest();
            if (response?.success) {
                setWinningTeams(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch winning teams data.");
        }
    };
    return {
        fetchWinningTeams,
    };
};